import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const DriverContext = createContext();
export const useDriver = () => useContext(DriverContext);

export const DriverProvider = ({ children }) => {
  const [driver, setDriver] = useState(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  const fetchDriverProfile = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${BASE_URL}/api/driver/profile`, {
        withCredentials: true,
      });
      setDriver(data);
    } catch (err) {
      if (err.response?.status === 401) {
        // Not logged in yet – expected
        setDriver(null);
      } else {
        console.error(
          "Failed to fetch driver profile:",
          err?.response?.data || err.message
        );
      }
    } finally {
      setLoading(false);
    }
  }, [BASE_URL]);

  const logout = async () => {
    try {
      await axios.post(`${BASE_URL}/api/driver/logout`, {}, { withCredentials: true });
    } catch (err) {
      console.error("Driver logout failed:", err?.response?.data || err.message);
    } finally {
      setDriver(null);
    }
  };

  // Fetch profile on first load
  useEffect(() => {
    fetchDriverProfile();
  }, [fetchDriverProfile]);

  return (
    <DriverContext.Provider value={{ driver, setDriver, loading, fetchDriverProfile, logout }}>
      {children}
    </DriverContext.Provider>
  );
};
